import React from "react";

import firstImage from "../../../assets/homepage/hero/services/image 118.png";
import secondImage from "../../../assets/homepage/hero/services/image 119.png";
import thirdImage from "../../../assets/homepage/hero/services/image 126.png";
import { useNavigate } from "react-router-dom";

const HomePageCards = () => {
  const navigate = useNavigate(); // Add this line to use the useNavigate hook

  // ... rest of your component code ...

  const handleGetLoan = () => {
    navigate("/GetLoanPage"); // Redirect to inquiries page
  };

  return (
    <div className="flex flex-col md:flex-row lg:flex-col md:gap-x-[20px] gap-y-[10px]">
      <div className=" flex flex-col w-[227px] h-[152px] bg-[#fff0c4] rounded-[8px]">
        <div className="flex flex-col justify-start items-center h-[152px] pt-[5px]">
          <div className="flex items-center text-left pl-[12px]">
            <div className="text-[14px] mb-2 font-semibold select-none">
              Looking For a product?
            </div>
            <img src={firstImage} className="h-[86px] w-[107px]" alt="BuyImg" />
          </div>
          <div className="mt-[5px] md:mt-[10px] w-[227px] flex items-center justify-center">
            <button className="border border-[#CF7E4A] rounded-[5px] text-[#CF7E4A] font-semibold w-[199px] h-[33px] text-[14px] select-none">
              Post Buy Requirement
            </button>
          </div>
        </div>
      </div>

      <div className=" flex flex-col w-[227px] h-[152px] bg-[rgba(227,105,110,255)] rounded-[8px]">
        <div className="flex flex-col justify-center items-center h-[200px] pt-[5px]">
          <div className="flex items-center text-left pl-[12px] mb-[10px]">
            <div className="text-[14px] mb-2 text-white font-semibold select-none">
              Want to Grow Business 10X Faster?
            </div>
            <img
              src={secondImage}
              className="h-[51px] w-[62px]"
              alt="SellImg"
            />
          </div>
          <div className="mt-[5px] w-[227px] flex items-center justify-center">
            <button className="border border-white rounded-[5px] text-white font-semibold w-[199px] h-[33px] text-[14px] mt-[10px]">
              Sell On Naayatrade
            </button>
          </div>
        </div>
      </div>

      <div className=" flex flex-col w-[227px] h-[152px] bg-[rgba(236,155,64,255)] rounded-[8px]">
        <div className="flex flex-col justify-start items-center h-[152px] pt-[5px]">
          <div className="flex items-center text-left pl-[12px]">
            <div className="text-[14px] mb-2 font-semibold select-none">
              {" "}
              Need Instant Loan ?{" "}
            </div>
            <img
              src={thirdImage}
              className="h-[86px] w-[107px]"
              alt="LoanImg"
            />
          </div>
          <div className="mt-[5px] w-[227px] flex items-center justify-center">
            <button
              className="border border-white rounded-[5px] text-[#ffffff] font-semibold w-[199px] h-[33px] text-[14px] md:mt-[5px]"
              onClick={handleGetLoan}
            >
              Get Loan
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePageCards;
